import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { LeverandoerOpkraevningSearchComponent } from './leverandoer-opkraevning-search/leverandoer-opkraevning-search.component';
import { LeverandoerOpkraevningResultComponent } from './leverandoer-opkraevning-result/leverandoer-opkraevning-result.component';
import { LeverandoerOpkraevningDetailComponent } from './leverandoer-opkraevning-detail/leverandoer-opkraevning-detail.component';
import { LeverandoerOpkraevningService } from './leverandoer-opkraevning.service';

@Component({
  selector: 'app-risikoopkraevning-leverandoer',
  imports: [
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    ButtonModule,
    LeverandoerOpkraevningSearchComponent,
    LeverandoerOpkraevningResultComponent,
    LeverandoerOpkraevningDetailComponent,
  ],
  templateUrl: './risikoopkraevning-leverandoer.component.html',
  styleUrl: './risikoopkraevning-leverandoer.component.css',
})
export class RisikoopkraevningLeverandoerComponent {
  leverandoerOpkraevningService = inject(LeverandoerOpkraevningService);
  data = this.leverandoerOpkraevningService.datasource.data;
}
